import { Action } from 'redux'
import { Bill } from '../../types/bills'

export const SET_BILLS = 'SET_BILLS'
export const SET_BILLS_LOADING = 'SET_BILLS_LOADING'
export const SET_BILLS_ERROR = 'SET_BILLS_ERROR'
export const SET_SELECTED_BILL = 'SET_SELECTED_BILL'

interface SetBillsAction extends Action {
    type: typeof SET_BILLS
    bills: Bill[] | null
}

interface SetBillsLoadingAction extends Action {
    type: typeof SET_BILLS_LOADING
    loading: boolean
}

interface SetBillsErrorAction extends Action {
    type: typeof SET_BILLS_ERROR
    error: string | null
}

interface SetSelectedBillAction extends Action {
    type: typeof SET_SELECTED_BILL
    bill: Bill | null
}

export type BillingActionTypes = 
    | SetBillsAction 
    | SetBillsLoadingAction 
    | SetBillsErrorAction 
    | SetSelectedBillAction